let showedFreeDeliveryPopup = localStorage.getItem("showedFreeDeliveryPopup");

const showFreeDeliveryPopup = () => {
  // モーダルを表示する(KlaviyoのAPIを呼び出す)
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'XmKhfY']);


  localStorage.setItem("showedFreeDeliveryPopup", "true");
};
if (!showedFreeDeliveryPopup && (window.location.pathname.indexOf('/en') === 0 || window.location.pathname.indexOf('/en-bc') === 0 || window.location.href.indexOf('en.moln.com') != -1)) {
  showFreeDeliveryPopup();
}
